module.exports = __webpack_public_path__ + "img/ic_search-2.16ba5a44.svg";